export enum NextScreen {
  CHANGE_SERVER = 'changeServer',
  GET_PASSWORD = 'getPassword',
  PASSWORD_NOT_SET = 'passwordNotSet',
  /** @deprecated Not used in add-in */
  PROFILE_NOT_COMPLETED = 'profileNotCompleted',
  LANDING_PAGE = 'landingPage',
  SSO = 'sso',
  PPT_PLUGIN_NOT_ACCESSIBLE = 'pptPluginNotAccessible',
}

export interface SsoCredentials {
  authUrl: string;
  sessionId: string;
}
